module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-12.2fe03009.png";